import { ContactDetails } from '@/models/common/contact-details';
import { PublicationStatusInfo } from '@/models/common/publication-status-info';
import { UserEntityPermissionsType } from '@/models/users/user-permissions/user-entity-permissions';
import { BusinessOpeningHours } from './business-opening-hours';
import { BusinessFrontPageHighlight } from './business-front-page-highlight';

export class BusinessFrontPage {
    public id: number = 0;
    public businessId: number = 0;
    public publicationStatus: PublicationStatusInfo[] = [];
    public claim?: string;
    public subclaim?: string;
    public description?: string;
    public slug?: string;
    public contactDetails: ContactDetails = new ContactDetails();
    public openingHours: BusinessOpeningHours = new BusinessOpeningHours();
    public hasTimeSensitiveReferences: boolean = false;
    public hasCategorizedReferences: boolean = false;
    public hasCategories: boolean = false;
    public highlights: BusinessFrontPageHighlight[] = [];
    public mainImageUrl: string = '';

    public get permissionsGroupType(): UserEntityPermissionsType {
        return UserEntityPermissionsType.Businesses;
    }

    public get permissionsIdToCheck(): number {
        return this.businessId;
    }

    get hasAtLeastOneFrontPagePublished(): boolean {
        return this.publicationStatus.some(p => p.isPublished);
    }

    constructor(json?: any) {
        if (!json) {
            this.description = '';
            return;
        }

        Object.assign(
            this,
            json,
            { publicationStatus: json.publicationStatus ? json.publicationStatus.map((status: any) => new PublicationStatusInfo(status)) : [] },
            { contactDetails: new ContactDetails(json.contactDetails) },
            { openingHours: json.openingHours ? new BusinessOpeningHours(json.openingHours) : new BusinessOpeningHours() },
            { highlights: json.highlights ? json.highlights.map((highlight: any) => new BusinessFrontPageHighlight(highlight)) : [] },
            { mainImageUrl: json.mainImageUrl ? json.mainImageUrl : '' }
        );

        if (!this.description || this.description === '') {
            this.description = '';
        } else {
            const Entities = require('html-entities').AllHtmlEntities;
            const entities = new Entities();

            this.description = entities.decode(this.description);
        }
    }

    public clone(): BusinessFrontPage {
        const businessFrontPage = new BusinessFrontPage();

        businessFrontPage.id = this.id;
        businessFrontPage.businessId = this.businessId;
        businessFrontPage.publicationStatus.push(...this.publicationStatus.map((status: any) => new PublicationStatusInfo(status).clone()));
        businessFrontPage.claim = this.claim;
        businessFrontPage.subclaim = this.subclaim;
        businessFrontPage.description = this.description;
        businessFrontPage.slug = this.slug;
        businessFrontPage.contactDetails = this.contactDetails.clone();
        businessFrontPage.openingHours = this.openingHours.clone();
        businessFrontPage.hasTimeSensitiveReferences = this.hasTimeSensitiveReferences;
        businessFrontPage.hasCategorizedReferences = this.hasCategorizedReferences;
        businessFrontPage.hasCategories = this.hasCategories;
        businessFrontPage.highlights.push(...this.highlights.map(h => new BusinessFrontPageHighlight(h).clone()));
        businessFrontPage.mainImageUrl = this.mainImageUrl;

        return businessFrontPage;
    }
}
